import React, { useEffect, useState } from 'react'
import { BLOCKS, MARKS } from "@contentful/rich-text-types";
import Img from 'gatsby-image'
import fbIcon from '../../../assets/images/facebook.svg'
import ytIcon from '../../../assets/images/youtube.svg'
import fbIconWomen from '../../../assets/images/facebook-women.svg'
import ytIconWomen from '../../../assets/images/youtube-women.svg'
import tenaLogo from '../../../assets/images/logo.svg'
import tenaMujerIframe from '../../../assets/images/logo_tena_mujer.png'
import tenaLogoWomen from '../../../assets/images/logo-women.png'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import FormView from '../form-view/form-view'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Icon from '../../../shared/components/atoms/Icon/Icon'
import SEO from '../../../shared/components/seo'
import './webinar-content.scss'
import LayoutModal from '../../../shared/components/organisms/layoutModal/layout-modal';
import useHomeLinkMode from '../../../shared/hooks/useHomeLinkMode';
import { secureStorage } from '../../../shared/state/utils/utilities-secure-storage';
import { addNoScroll, removeNoScroll } from "../../../shared/state/utils/overflowHelper"
import useBrowserMode from '../../../shared/hooks/useBrowserMode';


const WebinarContent = props => {
    const { isMobile } = props;
    const webinarInfo = props.webinarInfo;
    const { homeLink } = useHomeLinkMode();
    const [iframeUser, setIframeUser ] = React.useState(null)
    const pyInfo = {
        COUNTRY_PHONE_PREFIX: '+595',
        COUNTRY_CODE: 11,
        CELL_DIG: 10,
        COUNTRY_NAME: 'Paraguay',
        CAPITAL_NAME: 'Asuncion',
        CAPITAL_CODE: 9399
    }

    const optionsInfoPrimary = {
        renderMark: {
            [MARKS.BOLD]: text => <><b>{text}</b><br /></>,
        }
    };

    const optionsInfoSecondary = {
        renderMark: {
            [MARKS.BOLD]: text => <><b>{text}</b><br /></>,
        },
        renderNode: {
            [BLOCKS.PARAGRAPH]: (node, next) => <div className="f-coatch-women-body-info-secondary"><p>{next}</p></div>
        }
    };

    const optionsInfoDate = {
        renderNode: {
            [BLOCKS.PARAGRAPH]: (node, next) => <div className="f-coatch-date"><p>{next}</p></div>
        }
    };

    const optionsInfoHour = {
        renderMark: {
            [MARKS.BOLD]: text => <><b>{text}</b><br /></>,
        },
        renderNode: {
            [BLOCKS.PARAGRAPH]: (node, next) => <div className="f-coatch-hour"><p>{next}</p></div>
        }
    };

    const {
        tituloConferencistasYAgenda, banner, identificadorWebinar,
        referenciasDeConferencistas, textoObjetivoWebinar, footerRedireccionContactenos,
        footerRedireccionFacebook, footerRedireccionTena,
        footerRedireccionYoutube, redireccionWhatsApp, profesiones, estadoWebinar, redireccionWebinar,
        tipoDeWebinar
    } = webinarInfo;

    // 'Después del Evento', 'En el Evento'
    const webinarStatus = estadoWebinar
    // const webinarStatus = 'Después del Evento'
    const [modalServiceError, setmodalServiceError] = useState(null)
    const infoRightRef = React.useRef(null);
    const [isPY, setisPY] = useState(false);
    const { isBrowser } = useBrowserMode();

    const handleRenderModal = () => {
        isBrowser && addNoScroll();
        return(
            <LayoutModal>
                <div className="f-webinar-video">
                    <div className="f-webinar-video-header">
                        <div className="f-webinar-video-header-left">
                            <div className="img-container">
                                <img src={tenaMujerIframe} alt="TENA Mujer logo" />
                            </div>
                            <p><Icon icon="icon-video" size="1" tagtype="i" /> Webinar TENA Mujer</p>
                        </div>
                        <div className="f-webinar-video-header-right">
                            <a href={homeLink + "webinar/ingresar/"} onClick={() => {removeNoScroll(); secureStorage.removeItem("userWebinarIframe")}} ><Icon icon="icon-sign-out white" size="1" tagtype="i" /></a>
                        </div>
                    </div>
                    <div className={iframeUser ? "f-webinar-video-body f-webinar-video-body--auto " : "f-webinar-video-body"}>
                        {iframeUser ? 
                        <>
                            <iframe id="ls_embed_1600902838" src={`https://eunoed.com/streamingParametros/?id=streamingTena&name=${iframeUser}`} width="100%" scrolling="no" frameborder="0" style={{overflow: "hidden", height: "700px"}} allowfullscreen onLoad="iFrameResize();"></iframe>
                            <script src="https://eunoed.com/streamingParametros/js/iframeResizer.min.js"></script>
                            <script type="text/javascript" data-embed_id="ls_embed_1600902838" src="https://livestream.com/assets/plugins/referrer_tracking.js"></script>
                        </>
                        :
                        <h2>No estás participando de éste evento.</h2>    
                    }
                    </div>
                </div>
            </LayoutModal>
        )
    }

    const handleInputChange = () => {

        setmodalServiceError(
            <div className="f-error-service-modal-curtain">
                <div className="f-error-service-modal-info">
                    <div className="f-error-service-close" onClick={() => setmodalServiceError(null)}>X</div>
                    Lo sentimos, tenemos un error en este momento, inténtalo de nuevo mas tarde.
                </div>
            </div>
        )
    }

    useEffect(() => {
        getCountryParam()
        document.addEventListener("errorServiceModal", handleInputChange);
        if(props.currentPage === "index"){
            infoRightRef.current.scrollIntoView({block: "start", behavior: "smooth"});
        }
        if(props.currentPage === "ver-webinar/"){
            let user = secureStorage.getItem("userWebinarIframe");
            setIframeUser(user);
        }
        return () => {
            document.removeEventListener("errorServiceModal", handleInputChange);
        }
    }, [])

    const getCountryParam = () => {
        let url_string = window.location.href;
        let url = new URL(url_string);
        let country = url.searchParams.get("c");

        if (country === 'py') {
            setisPY(true)
        }
    }

    const groupedConf = tipoDeWebinar !== "mujeres" && referenciasDeConferencistas.reduce((r, a) => {
        r[a.fechaConferencia.split('T')[0]] = [...r[a.fechaConferencia.split('T')[0]] || [], a];
        return r;
    }, {});

    const groupsKeys = Object.keys(groupedConf).sort(function (a, b) {
        return new Date(b.date) - new Date(a.date);
    });

    const getMonth = idMonth => {
        const listMonths = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Deciembre']
        return listMonths[idMonth - 1]
    }

    const getFormatedHour = hour => {
        return hour.split(':')[0] > 12 ?
            (hour.split(':')[0] - 12) < 10 ?
                '0' + (hour.split(':')[0] - 12) + ':' + hour.split(':')[1] + ' p.m. ' + process.env.THREE_CODE
                :
                (hour.split(':')[0] - 12) + ':' + hour.split(':')[1] + ' p.m. ' + process.env.THREE_CODE
            :
            (hour.split(':')[0]) < 10 ?
                '0' + (hour.split(':')[0]) + ':' + hour.split(':')[1] + ' a.m. ' + process.env.THREE_CODE
                :
                (hour.split(':')[0]) + ':' + hour.split(':')[1] + ' a.m. ' + process.env.THREE_CODE
    }

    const NextArrow = (props) => {
        const { onClick } = props;
        return (
            <div className="f-next-icon" onClick={onClick}>
                <Icon icon="icon-chevron-right" size="2" tagtype="i" />
            </div>
        );
    }
    const handleRenderCaregivers = () => {
        return (
            <div className="f-webiner-list-cards">
                {groupsKeys.map((dateWebinar, index) => {
                    return (
                        <div className={"f-date-group-cards " + (index % 2 !== 0 ? 'f-second-list' : '')} key={index}>
                            <div className="f-date-title-container">
                                <div className="f-date-day">
                                    {dateWebinar.split('-')[2]}
                                </div>
                                <div className="f-date-month">
                                    {getMonth(dateWebinar.split('-')[1])}
                                </div>
                            </div>
                            <div className="f-date-cards-list">
                                {groupedConf[dateWebinar].map((itemCard, indexDeep) => {
                                    const {
                                        imagenConferencista, fechaConferencia,
                                        tituloDelConferencista, nombreConferencista,
                                        nombreConferencia, banderaConferencista, memoriasConferencia
                                    } = itemCard;
                                    return (
                                        <div className={"f-coatch-card " + (webinarStatus === 'Después del Evento' && memoriasConferencia ? 'f-card-memories' : '')} key={indexDeep}>
                                            <div className="f-coatch-card-img-container">
                                                <img
                                                    className="f-coatch-card-img"
                                                    src={imagenConferencista.file.url}
                                                    alt={imagenConferencista.description}
                                                />
                                            </div>
                                            <div className="f-coatch-card-title">
                                                {documentToReactComponents(nombreConferencia.json)}
                                            </div>
                                            <div className="f-coatch-card-hour">
                                                <b>
                                                    {getFormatedHour(fechaConferencia.split('T')[1].split('-')[0])}
                                                </b>
                                            </div>
                                            <div className="f-coatch-title-country">
                                                <div className="f-country-flag">
                                                    <img
                                                        className="f-country-flag-img"
                                                        src={banderaConferencista.file.url}
                                                        alt={banderaConferencista.description}
                                                    />
                                                </div>
                                                <div className="f-coatch-title-container">
                                                    <div className="f-coatch-name">
                                                        <b>
                                                            {nombreConferencista}
                                                        </b>
                                                    </div>
                                                    <div className="f-coatch-title">
                                                        {tituloDelConferencista}
                                                    </div>
                                                </div>
                                            </div>

                                            {webinarStatus === 'Después del Evento' && memoriasConferencia &&
                                                <a className='f-memories-event' href={memoriasConferencia.file.url} rel="noopener noreferrer" target="_blank">
                                                    DESCARGAR MEMORIAS
                                                </a>
                                            }
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    )
                })}
            </div>
        )
    }

    const handleRenderWomen = () => {
        return (
            <>
                {referenciasDeConferencistas.map((itemCard, index) => {
                    const {
                        imagenConferencista, redesSocialesConferencista, titulosConferencista,
                        informacionCharlaConferencista, horasConferencia
                    } = itemCard;
                    return (
                        <div className={"f-coatch-women"} key={index}>
                            <div className={"f-coatch-women-header"}>
                                <div className="f-coatch-women-header-img">
                                    <img
                                        className="f-coatch-card-img"
                                        src={imagenConferencista.file.url}
                                        alt={imagenConferencista.description}
                                    />
                                </div>
                            </div>
                            <div className={"f-coatch-women-body"}>
                                <div className="f-coatch-women-body-info">
                                    {redesSocialesConferencista  && <div className="f-coatch-women-body-info-principal">
                                        {documentToReactComponents(redesSocialesConferencista.json, optionsInfoPrimary)}
                                    </div>}
                                    {titulosConferencista &&
                                        documentToReactComponents(titulosConferencista.json, optionsInfoSecondary)
                                    }
                                </div>
                                <div className="f-coatch-women-body-footer">
                                    <div className="f-coatch-women-body-footer-principal">
                                        {informacionCharlaConferencista && documentToReactComponents(informacionCharlaConferencista.json,optionsInfoDate)}
                                    </div>
                                    <div className="f-coatch-women-body-footer-secondary">
                                        { horasConferencia && documentToReactComponents(horasConferencia.json, optionsInfoHour)}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }
                )}
            </>
        )
    }

    var settings = {
        dots: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        // autoplay: true,
        // speed: tiempoBanner.velocidad_rotacion,
        // autoplaySpeed: tiempoBanner.tiempo_rotacion,
        nextArrow: <NextArrow />,
        adaptiveHeight: true
        // prevArrow: <PrevArrow />
    };

    return (
        <>
         { props.currentPage === "ver-webinar/" ? handleRenderModal() : null }
        <div className="f-webinar-content">
            <SEO title={'Webinar'} />
            {modalServiceError}
            {isMobile ?
                <Slider {...settings} className="f-slider-webinar">
                    <div className="f-webinnar-banner-item-container">
                        <div className="f-webinar-banner-container">
                            <Img fluid={banner[1].fluid} alt={banner[1].description} className="f-webinar-banner" />
                        </div>
                    </div>

                    {referenciasDeConferencistas.map((itemCard, index) => {
                        const {
                            imagenConferencista, fechaConferencia,
                            tituloDelConferencista, nombreConferencista,
                            nombreConferencia, banderaConferencista, memoriasConferencia
                        } = itemCard;
                        return (
                            <>
                                {
                                    tipoDeWebinar === "mujeres" ? handleRenderWomen() :
                                        <div className="f-webinnar-banner-item-container" key={index}>
                                            <div className="f-top-mobile-info">
                                                <img src={tenaLogo} className="f-icon-tena-logo-card-mobile" alt="Logo" />
                                                <div className="f-top-bottom-mobile-info">
                                                    <div className="f-top-bottom-left">
                                                        {tituloConferencistasYAgenda}
                                                    </div>
                                                    <div className="f-top-bottom-right">
                                                        <div className="f-date-day">
                                                            {fechaConferencia.split('T')[0].split('-')[2]}
                                                        </div>
                                                        <div className="f-date-month">
                                                            {getMonth(fechaConferencia.split('T')[0].split('-')[1])}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={"f-coatch-card " + (webinarStatus === 'Después del Evento' && memoriasConferencia ? 'f-card-memories' : '')}>
                                                <div className="f-coatch-card-img-container">
                                                    <img
                                                        className="f-coatch-card-img"
                                                        src={imagenConferencista.file.url}
                                                        alt={imagenConferencista.description}
                                                    />
                                                </div>
                                                <div className="f-coatch-card-title">
                                                    {documentToReactComponents(nombreConferencia.json)}
                                                </div>
                                                <div className="f-coatch-card-hour">
                                                    <b>
                                                        {getFormatedHour(fechaConferencia.split('T')[1].split('-')[0])}
                                                    </b>
                                                </div>
                                                <div className="f-coatch-title-country">
                                                    <div className="f-country-flag">
                                                        <img
                                                            className="f-country-flag-img"
                                                            src={banderaConferencista.file.url}
                                                            alt={banderaConferencista.description}
                                                        />
                                                    </div>
                                                    <div className="f-coatch-title-container">
                                                        <div className="f-coatch-name">
                                                            <b>
                                                                {nombreConferencista}
                                                            </b>
                                                        </div>
                                                        <div className="f-coatch-title">
                                                            {tituloDelConferencista}
                                                        </div>
                                                    </div>
                                                </div>

                                                {webinarStatus === 'Después del Evento' && memoriasConferencia &&
                                                    <a className='f-memories-event' href={memoriasConferencia.file.url} rel="noopener noreferrer" target="_blank">
                                                        DESCARGAR MEMORIAS
                                                    </a>
                                                }
                                            </div>
                                        </div>
                                }
                            </>
                        )
                    })}
                </Slider>
                :
                <div className="f-webinar-banner-container">
                     <Img fluid={banner[0].fluid} alt={banner[0].description} className="f-webinar-banner" />
                </div>
            }
            <div className="f-webinar-info-container">
                <div className="f-webinar-info">
                    {!isMobile &&
                        <div className="f-webinar-info-letf">
                            <h1 className={tipoDeWebinar === "mujeres" ? "f-webiner-title f-webiner-title--women" : "f-webiner-title"}>
                                {tituloConferencistasYAgenda}
                            </h1>
                            {tipoDeWebinar === "mujeres" ? handleRenderWomen() : handleRenderCaregivers()}
                        </div>
                    }
                    <div ref={infoRightRef} className="f-webinar-info-right">
                        <FormView
                            textoObjetivoWebinar={textoObjetivoWebinar}
                            identificadorWebinar={identificadorWebinar}
                            redireccionWhatsApp={redireccionWhatsApp}
                            profesiones={profesiones}
                            webinarStatus={webinarStatus}
                            isPY={isPY}
                            pyInfo={pyInfo}
                            redireccionWebinar={redireccionWebinar}
                            isWomenWebinar={tipoDeWebinar === "mujeres"}
                            currentStep={props.currentPage}
                        />
                    </div>
                </div>
            </div>
            <footer className={ tipoDeWebinar === "mujeres" ? "f-webinar-footer f-webinar-footer--women" : "f-webinar-footer"}>
                <div className="f-webinar-footer-info">
                    {tipoDeWebinar === "mujeres" ? null : <div className="f-footer-texture-container"><div className="f-footer-texture"></div></div>}
                    <div className="f-footer-mobile-flex">
                        <div className="f-webinar-footer-links">
                            <a href={footerRedireccionTena} className="f-footer-redirect-container" rel="noopener noreferrer" target="_blank">
                                www.TENA.com
                            </a>
                            <span className="f-separator-footer">
                                /
                            </span>
                            <a href={footerRedireccionFacebook} className="f-footer-redirect-container" rel="noopener noreferrer" target="_blank">
                                <img src={tipoDeWebinar === "mujeres" ? fbIconWomen : fbIcon} className="f-icon-link" alt="icono" /> Bienestar by TENA
                            </a>
                            <span className="f-separator-footer">
                                /
                            </span>
                            <a href={footerRedireccionYoutube} className="f-footer-redirect-container" rel="noopener noreferrer" target="_blank">
                                <img src={tipoDeWebinar === "mujeres" ? ytIconWomen : ytIcon} className="f-icon-link ty-icon" alt="icono" /> TENA
                            </a>
                        </div>

                        <div className="f-webinar-footer-contact-faq">
                            {/* <a href={footerRedireccionPreguntasFrecuentes} className="f-webinar-footer-faq" rel="noopener noreferrer" target="_blank">Preguntas frecuentes</a> */}
                            <a href={footerRedireccionContactenos} className="f-webinar-footer-contact" rel="noopener noreferrer" target="_blank">Contáctenos</a>
                        </div>
                    </div>

                    <div className="f-webinar-footer-logo">
                        <img src={tipoDeWebinar === "mujeres" ? tenaLogoWomen : tenaLogo } className="f-icon-tena-logo" alt="Logo" />
                    </div>
                </div>
            </footer>

        </div>
        </>
    )
}

export default WebinarContent
